import {
  BatchUpdateListingActions,
  BatchUpdateListingMutations,
  BatchUpdateListingGetters
} from '@/app/features/batch-update/batch-update-listing.keys';
import { batchUpdateListingService as svc } from '@/app/features/batch-update/batch-update-listing-service';

export const getInitialState = () => {
  return {
    batchUpdateResultList: [],
    batchActionParams: {},
    batchUpdateTolObject: null,
    batchUpdateSuccess: null,
    batchUpdateResultObjects: [],
    selectedBatchResults: [],
    IsBatchPdfGenerated: false
  };
};

export const batchUpdateListingStore = {
  state: getInitialState(),
  getters: {
    [BatchUpdateListingGetters.BatchUpdateResult]: state => {
      return state.batchUpdateResultList;
    },
    [BatchUpdateListingGetters.BatchUpdateTolObject]: state => {
      return state.batchUpdateTolObject;
    },
    [BatchUpdateListingGetters.IsAllUpdateSuccess]: state => {
      return (
        state.batchUpdateResultObjects.length > 0 &&
        state.batchUpdateResultObjects.map(o => o.result).every(item => item !== null) &&
        !state.batchUpdateResultObjects.map(o => o.result).some(item => 'errors' in item)
      );
    },
    [BatchUpdateListingGetters.IsAllResultsSelected]: state => {
      const allRefs = state.batchUpdateResultList.map(r => r.reference_number);
      return (
        state.selectedBatchResults.length !== 0 &&
        state.batchUpdateResultList.length !== 0 &&
        JSON.stringify(state.selectedBatchResults) == JSON.stringify(allRefs)
      );
    },
    [BatchUpdateListingGetters.SelectedBatchResults]: state => {
      return state.selectedBatchResults;
    },
    [BatchUpdateListingGetters.IsBatchPdfGenerated]: state => {
      return state.IsBatchPdfGenerated;
    }
  },
  actions: {
    [BatchUpdateListingActions.RetrieveBatchUpdateResultList]: ({ commit }, params) => {
      commit(BatchUpdateListingMutations.SetBatchUpdateTolObject, params.advancedSearchTable);
      commit(BatchUpdateListingMutations.SetBatchUpdateResultObjects, params.batchResults);
      const batchResults = params.batchResults;
      delete params.batchResults;
      return svc.retrieveBatchUpdateResults(params).then(result => {
        result = result.map(res => {
          let currentResult = batchResults.filter(r => {
            return r.reference_number === res.reference_number;
          })[0].result;
          let message =
            currentResult !== null && !('errors' in currentResult) ? 'Success' : 'Error';
          let msgString =
            currentResult && currentResult.hasOwnProperty('errors')
              ? (() => {
                  let res = [];
                  for (let i in currentResult.errors) {
                    res.push(currentResult.errors[i].join());
                  }
                  return res;
                })()
              : [];
          return { ...res, result: message, message: msgString }; //TODO . Correct messge must be sent from api
        });
        commit(BatchUpdateListingMutations.RetrieveBatchUpdateSuccess, result);
      });
    },
    [BatchUpdateListingActions.ToggleSelectBatchResult]: ({ commit }, ref) => {
      commit(BatchUpdateListingMutations.UpdateSelectedBatchResults, ref);
    },
    [BatchUpdateListingActions.SelectDeselectAllResults]: ({ commit }, evt) => {
      commit(BatchUpdateListingMutations.SelectDeselectResults, evt);
    },
    [BatchUpdateListingActions.SetBatchPdfGenerated]: ({ commit }, evt) => {
      commit(BatchUpdateListingMutations.SetBatchPdfGenerated, evt);
    }
  },
  mutations: {
    [BatchUpdateListingMutations.RetrieveBatchUpdateSuccess]: (state, result) => {
      state.batchUpdateResultList = result;
    },
    [BatchUpdateListingMutations.SetBatchActionParams]: (state, params) => {
      state.batchActionParams = params;
    },
    [BatchUpdateListingMutations.SetBatchUpdateTolObject]: (state, tolObject) => {
      state.batchUpdateTolObject = tolObject;
    },
    [BatchUpdateListingMutations.SetBatchUpdateResultObjects]: (state, batchResult) => {
      state.batchUpdateResultObjects = batchResult;
    },
    [BatchUpdateListingMutations.UpdateSelectedBatchResults]: (state, payload) => {
      const idx = state.selectedBatchResults.findIndex(ref => ref === payload);
      let newSelected;
      if (idx >= 0) {
        newSelected = state.selectedBatchResults.filter(ref => ref !== payload);
      } else {
        newSelected = state.selectedBatchResults.slice();
        newSelected.push(payload);
      }
      state.selectedBatchResults = newSelected;
    },
    [BatchUpdateListingMutations.SelectDeselectResults]: (state, isSelected) => {
      state.selectedBatchResults = isSelected
        ? state.batchUpdateResultList.map(r => r.reference_number)
        : [];
    },
    [BatchUpdateListingMutations.SetBatchPdfGenerated]: (state, result) => {
      state.IsBatchPdfGenerated = result;
    }
  }
};
